<!-- Container -->
<div class="kt-container-fixed flex items-center justify-between lg:gap-4" id="headerContainer">
  <app-logo></app-logo>
</div>
<!-- End of Container -->
